// extracted by mini-css-extract-plugin
export default {"wrapper":"CallButton_wrapper__QJVLR","icon":"CallButton_icon__BpleQ"};